import { parseISO, format, addMinutes } from 'date-fns';

export function convertToIST(timestamp: string): string {
    const date = parseISO(timestamp);
    const istDate = addMinutes(date, 330); 
    const istTime = format(istDate, 'dd MMM yyyy');

    return istTime;
}
